import { jsx as f } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.es.js";
import { WorkingTurnsColors as a } from "../../foundations/palette.es.es.js";
import { BoltSquareAltSolid as l } from "./bolt-square-alt-solid.es.es.js";
import { FileCheckSolid as e } from "./file-check-solid.es.es.js";
import { HourglassSolid as n } from "./hourglass-solid.es.es.js";
const c = {
  cafOperator: /* @__PURE__ */ f(n, { style: {
    color: a.cafOperator
  } }),
  user: /* @__PURE__ */ f(l, { style: {
    color: a.user
  } }),
  finalized: /* @__PURE__ */ f(e, { style: {
    color: a.finalized
  } })
};
export {
  c as TurnIcons
};
//# sourceMappingURL=turn-icons.es.es.js.map
